module.exports = __webpack_public_path__ + "assets/img/linux.740cf92dd05934a55a187a77a0ed5aaf.svg";